<template>
  <div ref="box" class="lottie-player" aria-hidden="true"></div>
</template>

<script>
// Adapter: adapta la API imperativa de lottie-web (loadAnimation/destroy) a props de Vue.
// Versión "light" (solo SVG, sin expresiones): pesa menos y alcanza para estas animaciones.
import lottie from "lottie-web/build/player/lottie_light";

export default {
  name: "LottiePlayer",
  props: {
    animation: { type: Object, required: true },
    speed: { type: Number, default: 1 },
    // false: se reproduce una vez y queda en el último cuadro (íconos de estado).
    loop: { type: Boolean, default: true },
    // Cuadro que se muestra quieto en loop si el usuario pidió menos movimiento (prefers-reduced-motion).
    stillFrame: { type: Number, default: 20 },
  },
  watch: {
    speed(value) {
      if (this.player) this.player.setSpeed(value);
    },
  },
  mounted() {
    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.player = lottie.loadAnimation({
      container: this.$refs.box,
      renderer: "svg",
      loop: this.loop,
      autoplay: !reduceMotion,
      animationData: this.animation,
    });
    this.player.setSpeed(this.speed);
    if (reduceMotion) this.player.goToAndStop(this.loop ? this.stillFrame : this.player.totalFrames - 1, true);
  },
  beforeDestroy() {
    if (this.player) this.player.destroy();
  },
};
</script>

<style scoped>
.lottie-player {
  width: 100%;
  height: 100%;
}
</style>
